// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export interface Document {
  [key: string]: any;
}
